import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { adminService } from '../../services/admin.service';

const AdminNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    adminService.logout();
    navigate('/pmpl/admin');
  };

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <Nav>
      <NavLeft>
        <Title>Panel de Administración</Title>
        <NavLinks>
          <NavLink
            active={isActive('/pmpl/admin/dashboard')}
            onClick={() => navigate('/pmpl/admin/dashboard')}
          >
            Campañas
          </NavLink>
          <NavLink
            active={isActive('/pmpl/admin/domains')}
            onClick={() => navigate('/pmpl/admin/domains')}
          >
            Dominios
          </NavLink>
          <NavLink
            active={isActive('/pmpl/admin/api-keys')}
            onClick={() => navigate('/pmpl/admin/api-keys')}
          >
            API Keys
          </NavLink>
        </NavLinks>
      </NavLeft>
      <LogoutButton onClick={handleLogout}>Cerrar Sesión</LogoutButton>
    </Nav>
  );
};

const Nav = styled.nav`
  background: #1a1a1a;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #333;
`;

const NavLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

const Title = styled.h1`
  color: #ffd700;
  margin: 0;
  font-size: 1.5rem;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const NavLink = styled.button`
  background: ${props => props.active ? 'rgba(255, 215, 0, 0.2)' : 'transparent'};
  color: ${props => props.active ? '#ffd700' : '#999'};
  border: 1px solid ${props => props.active ? 'rgba(255, 215, 0, 0.3)' : '#444'};
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
  }
`;

const LogoutButton = styled.button`
  background: transparent;
  color: #fff;
  border: 1px solid #444;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export default AdminNavbar; 